export const STATUS = {
  CONNECTING: 'CONNECTING',
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  OFFLINE: 'OFFLINE',
  ERROR: 'ERROR',
};
